<template>
  <div>

    <!-- validate token -->
    <transition name="slide-fade" enter-active-class="animated flipInY" leave-active-class="animated fadeOut" mode="out-in">
      <div id="verify-token-card" v-if="state == 1" key="loader">
        <h3>Validating token</h3>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>

      <div class="sign-in-card" v-if="state == 2" key="form">

        <div class="card-header">
          <h3>{{ username }}</h3>
        </div>

        <div class="card-body">
          <form v-on:submit.prevent>
            <v-text-field
            v-model="password"
            :prepend-icon="'lock'"
            :append-icon="p1 ? 'visibility' : 'visibility_off'"
            @click:append="() => (p1 = !p1)"
            :type="p1 ? 'password' : 'text'"
            label="New Password"
            spellcheck="false"
            hint="At least 8 characters"
            min="8"
            color="deep-purple"
            ></v-text-field>
            <v-text-field
            v-model="password_confirmation"
            :prepend-icon="'lock'"
            :append-icon="p2 ? 'visibility' : 'visibility_off'"
            @click:append="() => (p2 = !p2)"
            :type="p2 ? 'password' : 'text'"
            label="Repeat Password"
            spellcheck="false"
            hint="At least 8 characters"
            min="8"
            color="deep-purple"
            :error="showPasswordError"
            :rules="rules"
          ></v-text-field>
          <p v-if="error.length > 0" class="error-text">
            {{ error }}
          </p>
            <v-btn 
            block
            @click="resetPassword"
            :loading="loading"
            :disabled="disableSubmitButton"
            class="white--text"
            color="deep-purple"
            >Reset password</v-btn>
            <router-link to="/auth/sign-in" style="text-decoration: none;">
              <v-btn text color="green">
                <v-icon>mdi-arrow-left</v-icon>Back
              </v-btn>
            </router-link>
          </form>

        </div>
      </div>

  <!-- token not found -->
    <div id="token-expired-card" v-if="state == -1" key="tokenExpired">
      <v-icon x-large color="blue-grey lighten-2">error_outline</v-icon>
      <h3>The reset token has expired or is invalid.</h3>
    </div>
  </transition>

  <!-- dialog -->
  <v-dialog v-model="dialog" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">Password updated!</v-card-title>
      <v-card-text>You can now sign in with your new password.</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined color="green darken-1" @click="redirectToSignin">Sign in</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      email: '',
      password: '',
      password_confirmation: '',
      p1: true,
      p2: true,
      state: 1,
      loading: false,
      rules: [],
      dialog: false,
      error: ''
    }
  },
  computed: {
    showPasswordError: function () {
      if (this.password_confirmation.length > 0 && this.password !== this.password_confirmation) {
        this.rules = [() => 'Passwords don\'t match']
        return true
      } else {
        this.rules = []
        return false
      }
    },
    disableSubmitButton: function () {
      if (this.showPasswordError || this.loading || this.password_confirmation.length < 1) {
        return true
      }
      return false
    }
  },
  methods: {
    verifyToken () {
      this.$axios.post('users/password/verify-token',
        {token: this.$route.query.token},
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            console.log(response)
            this.username = response.data.username
            this.state = 2
          })
        .catch(
          (error) => {
            console.log(error)
            this.state = -1
          })
        // */
    },
    resetPassword () {
      this.loading = true
      this.$axios.post('users/password/reset-with-email-token',
        {token: this.$route.query.token,
          password: this.password},
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            this.dialog = true
          })
        .catch(
          (error) => {
            this.error = 'This reset token has expired'
            console.log(error)
          })
        .then(() => {
          this.loading = false
        })
        // */
    },
    redirectToSignin () {
      this.$router.push('/auth/sign-in')
    }
  },
  mounted () {
    this.verifyToken()
  }
}
</script>

<style scoped>
.card-header {
  border-bottom: 1px solid #EEE;
  padding: 10px;
}

.card-body {
  padding: 20px;
}

.sign-in-card {
  display: inline-block;
  background: white;
  width: 300px;
  border-radius: 4px;
  box-shadow: 2px 2px 10px rgba(0,0,0,0.4);
}

.white-text {
  color: white;
  text-transform: none;
}

h2 {
  text-align: center;
  color: white;
}

a {
  margin-left: auto;
  text-decoration: none;
  display:block;
  color: #BBB;
}

a:active {
  color: purple;
}

a:hover {
  color: purple;
  text-decoration: underline;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

#verify-token-card {
  display: inline-block;
  background: white;
  border-radius: 4px;
  box-shadow: 2px 2px 10px rgba(0,0,0,0.4);
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #90A4AE;
}

#token-expired-card {
  display: inline-block;
  background: white;
  border-radius: 4px;
  box-shadow: 2px 2px 10px rgba(0,0,0,0.4);
  padding: 30px;
  display: flex;
  align-items: center;
  color: #90A4AE;
}
.error-text {
  color: #AD1457;
  text-align: center;
}

</style>
